/* ============================================================================
   ft-mobile-inputmode.js
   60ft Ink · 5 September 2026

   M2 — the wrong keyboard on the quantity boxes.

   There are twelve number inputs in the order path. Only three carry an
   inputmode attribute. On the other nine, a phone opens the full QWERTY
   keyboard with numbers on a secondary layer, so entering a quantity is two
   taps instead of one, on a control the customer uses five or six times in a
   single order.

   inputmode="numeric" tells the phone to open the number pad. It does not
   change validation, does not change what the field accepts, and desktop
   ignores it entirely.

   This is a script rather than CSS because the size/quantity matrix is
   rendered by JavaScript after page load, so the inputs do not exist when the
   stylesheet is applied. A MutationObserver catches them as they appear —
   including on colour change, when the matrix is rebuilt.

   Deliberately narrow: it only ever ADDS attributes, only to number inputs,
   and never touches an input that already declares its own inputmode.
   ============================================================================ */

(function () {
  'use strict';

  var SELECTOR = 'input[type="number"]';

  function tag(input) {
    if (!input || input.dataset.ftInputmode === '1') return;

    // Respect anything the theme has already declared.
    if (!input.hasAttribute('inputmode')) {
      input.setAttribute('inputmode', 'numeric');
    }

    // Quantity fields are whole units. Nudges the number pad away from a
    // decimal layout on Android and stops the browser offering odd
    // autocomplete values.
    if (!input.hasAttribute('pattern')) {
      input.setAttribute('pattern', '[0-9]*');
    }
    if (!input.hasAttribute('autocomplete')) {
      input.setAttribute('autocomplete', 'off');
    }

    input.dataset.ftInputmode = '1';
  }

  function sweep(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTOR)) tag(root);
    var found = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < found.length; i++) tag(found[i]);
  }

  function start() {
    sweep(document.body);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) sweep(added[j]);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
